/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BooksLibraryIcon16Solid = forwardRef('BooksLibraryIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.173 3.974a1.5 1.5 0 0 0-2.846-.948l-3 9a1.5 1.5 0 1 0 2.846.948l3-9Z" }),
        React.createElement("path", { d: "M9.5 2A1.5 1.5 0 0 1 11 3.5v9a1.5 1.5 0 1 1-3 0v-9A1.5 1.5 0 0 1 9.5 2Z" }),
        React.createElement("path", { d: "M13.5 2A1.5 1.5 0 0 1 15 3.5v9a1.5 1.5 0 1 1-3 0v-9A1.5 1.5 0 0 1 13.5 2Z" })));
});
